(function ($) {
  "use strict";

  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  window.showAlert = (messageType, message) => {
    if (messageType === "alert-danger") {
      messageType = "error";
    }

    if (messageType === "alert-success") {
      messageType = "success";
    }

    Theme.showNotice(messageType, message);
  };

  function handleError(error, $form = null) {
    if (typeof Theme !== "undefined") {
      Theme.handleError(error, $form);
    } else {
      console.error("[Ecommerce]", error.responseJSON?.message || error.statusText || error);
    }
  }

  $(function () {
    function ajaxUpdateCart(_self) {
      _self.closest(".ps-table--shopping-cart").addClass("content-loading");

      $.ajax({
        type: "POST",
        cache: false,
        url: _self.closest("form").prop("action"),
        data: new FormData(_self.closest("form")[0]),
        contentType: false,
        processData: false,
        success: (res) => {
          if (res.error) {
            Theme.showError(res.message);
            _self.closest(".ps-table--shopping-cart").removeClass("content-loading");
            _self.closest(".product__qty").find(".qty-input").val(res.data.count).prop("placeholder", res.data.count);
            return false;
          }

          $(".ps-section--shopping").load(window.location.href + " .ps-section--shopping > *", function () {
            if (typeof Theme.lazyLoadInstance !== "undefined") {
              Theme.lazyLoadInstance.update();
            }
          });

          $.ajax({
            url: window.siteUrl + "/ajax/cart",
            method: "GET",
            success: (response) => {
              if (!response.error) {
                _self.closest(".ps-table--shopping-cart").removeClass("content-loading");
                $(".ps-cart--mobile").html(response.data.html);
                $(".cart-item-count").text(response.data.count);
                Theme.showSuccess(res.message);

                if (typeof Theme.lazyLoadInstance !== "undefined") {
                  Theme.lazyLoadInstance.update();
                }
              }
            },
            error: (res) => {
              _self.closest(".ps-table--shopping-cart").removeClass("content-loading");
              Theme.showError(res.message);
            },
          });
        },
        error: (res) => {
          _self.closest(".ps-table--shopping-cart").removeClass("content-loading");
          Theme.showError(res.message);
        },
      });
    }

    $(document).on("click", ".our-products .products-tabs .btn-tab", function (e) {
      e.preventDefault();
      const _self = $(e.currentTarget);

      if (_self.hasClass("active")) {
        return;
      }

      const $tabContent = _self.closest(".our-products");
      $tabContent.find(".products-tabs .btn-tab").removeClass("active");
      _self.addClass("active");

      const $wrapper = $tabContent.find(".products-grid-wrapper");
      $wrapper.addClass("is-loading");

      $.ajax({
        url: _self.data("url"),
        method: "GET",
        success: (res) => {
          if (res.error) {
            Theme.showError(res.message);
            $wrapper.removeClass("is-loading");
            return false;
          }

          $tabContent.find(".products-grid-content").html(res.data);
          $wrapper.removeClass("is-loading");

          if (typeof Theme.lazyLoadInstance !== "undefined") {
            Theme.lazyLoadInstance.update();
          }
        },
        error: (res) => {
          Theme.showError(res.message);
          $wrapper.removeClass("is-loading");
        },
      });
    });

    $(document).on("click", ".newsletter__form button[type=submit]", function (event) {
      event.preventDefault();
      event.stopPropagation();

      let _self = $(this);

      _self.addClass("button-loading");
      _self.attr("disabled", true);

      $.ajax({
        type: "POST",
        cache: false,
        url: _self.closest("form").prop("action"),
        data: new FormData(_self.closest("form")[0]),
        contentType: false,
        processData: false,
        success: (res) => {
          _self.removeClass("button-loading");
          _self.attr("disabled", false);

          if (typeof refreshRecaptcha !== "undefined") {
            refreshRecaptcha();
          }

          if (!res.error) {
            _self.closest("form").find("input[type=email]").val("");
            showSuccess(res.message);
          } else {
            showError(res.message);
          }
        },
        error: (res) => {
          if (typeof refreshRecaptcha !== "undefined") {
            refreshRecaptcha();
          }
          _self.removeClass("button-loading");
          _self.attr("disabled", false);
          handleError(res);
        },
      });
    });

    $(document).on("click", ".productDetail__quantity .up", function (event) {
      event.preventDefault();
      event.stopPropagation();
      let currentVal = parseInt($(this).closest(".productDetail__quantity").find(".qty-input").val(), 10);
      $(this)
        .closest(".productDetail__quantity")
        .find(".qty-input")
        .val(currentVal + 1)
        .prop("placeholder", currentVal + 1)
        .trigger("change");

      if ($(this).closest(".ps-table--shopping-cart").length) {
        ajaxUpdateCart($(this));
      }
    });

    $(document).on("click", ".productDetail__quantity .down", function (event) {
      event.preventDefault();
      event.stopPropagation();
      let currentVal = parseInt($(this).closest(".productDetail__quantity").find(".qty-input").val(), 10);
      if (currentVal > 1) {
        $(this)
          .closest(".productDetail__quantity")
          .find(".qty-input")
          .val(currentVal - 1)
          .prop("placeholder", currentVal - 1)
          .trigger("change");
      }

      if ($(this).closest(".ps-table--shopping-cart").length) {
        ajaxUpdateCart($(this));
      }
    });

    $(document).on("click", ".productDetail .productDetail__actions button[type=submit]", function (event) {
      event.preventDefault();
      event.stopPropagation();

      let _self = $(this);

      if (!$(".hidden-product-id").val()) {
        _self.prop("disabled", true).addClass("btn-disabled");
        return;
      }

      _self.prop("disabled", true).addClass("btn-disabled").addClass("button-loading");
      _self.closest("form").find(".error-message").hide();
      _self.closest("form").find(".success-message").hide();

      let $form = _self.closest("form");

      let data = $form.serializeArray();
      data.push({ name: "checkout", value: _self.prop("name") === "checkout" ? 1 : 0 });

      $.ajax({
        type: "POST",
        url: $form.prop("action"),
        data: $.param(data),
        success: (res) => {
          _self.prop("disabled", false).removeClass("btn-disabled").removeClass("button-loading");

          if (res.error) {
            _self.removeClass("button-loading");

            const $available = $form.find(".error-message");
            if ($available.length) {
              $available.html(`<span class='text-danger'>${res.message}</span>`).show();
            } else {
              Theme.showError(res.message);
            }

            if (res.data && res.data.next_url !== undefined) {
              window.location.href = res.data.next_url;
            }

            return false;
          }

          // Client wants to disable a toast message in this case
          // Theme.showSuccess(res.message);

          if (res.data.next_url !== undefined) {
            window.location.href = res.data.next_url;
          } else {
            $.ajax({
              url: window.siteUrl + "/ajax/cart",
              method: "GET",
              success: function (response) {
                if (!response.error) {
                  $(".ps-cart--mobile").html(response.data.html);
                  $(".cart-item-count").text(response.data.count);

                  if (typeof Theme.lazyLoadInstance !== "undefined") {
                    Theme.lazyLoadInstance.update();
                  }
                }
              },
            });
          }
        },
        error: (res) => {
          _self.prop("disabled", false).removeClass("btn-disabled").removeClass("button-loading");
          handleError(res, _self.closest("form"));
        },
      });
    });

    $(document).on("click", ".product-card .product-actions .add-to-cart-button", function (event) {
      event.preventDefault();
      let _self = $(this);

      _self.prop("disabled", true).addClass("button-loading");

      $.ajax({
        url: _self.data("url"),
        method: "POST",
        data: {
          id: _self.data("id"),
        },
        dataType: "json",
        success: (res) => {
          _self.prop("disabled", false).removeClass("button-loading").addClass("active");

          if (res.error) {
            const $available = _self.closest(".add-to-cart-form").find(".number-items-available");
            if ($available.length) {
              $available.html(`<span class='text-danger'>${res.message}</span>`).show();
            } else {
              Theme.showError(res.message);
            }
            if (res.data.next_url !== undefined) {
              setTimeout(() => {
                window.location.href = res.data.next_url;
              }, 500);
            }

            return false;
          }

          Theme.showSuccess(res.message);

          Cart.handleUpdateCartContent();

          if (res.data.next_url !== undefined) {
            window.location.href = res.data.next_url;
          } else {
            $.ajax({
              url: window.siteUrl + "/ajax/cart",
              method: "GET",
              success: (response) => {
                if (!response.error) {
                  $(".ps-cart--mobile").html(response.data.html);
                  $(".cart-item-count").text(response.data.count);

                  if (typeof Theme.lazyLoadInstance !== "undefined") {
                    Theme.lazyLoadInstance.update();
                  }
                }
              },
            });
          }
        },
        error: (res) => {
          _self.prop("disabled", false).removeClass("button-loading");
          Theme.showError(res.message);
        },
      });
    });
  });

  $(document).ready(function () {
    window.onBeforeChangeSwatches = function (data, $attrs) {
      const $product = $attrs.closest(".productDetail");
      const $form = $product.find(".add-to-cart-form");

      $product.find(".error-message").hide();
      $product.find(".success-message").hide();
      // $product.find(".number-items-available").html("").hide();

      if (data && data.attributes) {
        $form.find(".productDetail__cartBtn").prop("disabled", true).addClass("btn-disabled");
      }
    };

    $(document).ready(function () {
      let originalOnChangeSwatchesSuccess = window.onChangeSwatchesSuccess;

      window.onChangeSwatchesSuccess = function (res, $attrs) {
        if (originalOnChangeSwatchesSuccess && typeof originalOnChangeSwatchesSuccess === "function") {
          originalOnChangeSwatchesSuccess(res, $attrs);
        }

        if (res && !res.error && res.data) {
          const data = res.data;
          $(".hidden-product-id").val(data.id);
        }
      };
    });
  });
})(jQuery);
